import GoogleMapsLoader from 'google-maps';
import EventEmitter from 'events';
import {mapOptions, mapStyles} from './map-options';
import global from '../../global';

let events = new EventEmitter();

let mapContainer;
let _g;
let _geocoder;
let _places;

let map;
let markerCount;
let markers;
let bounds;
let promises;
let activeMarker;

function start(container, places) {
	mapContainer = container;
	markers = {};
	GoogleMapsLoader.KEY = global.MAP_KEY;
	GoogleMapsLoader.load(loadMap);
	_places = places;
	promises = [];
}

function loadMap(google) {
	mapOptions.mapTypeControlOptions = {
		mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
	};
	_g = google;
	const slxStyledMap = new _g.maps.StyledMapType(mapStyles, {name: 'Selux'});
	map = new _g.maps.Map(mapContainer, mapOptions);
	_geocoder = new _g.maps.Geocoder();
	bounds = new _g.maps.LatLngBounds();
	markerCount = 1;

	if (_places) {
		_places.forEach(place => promises.push(setMarker(place)));
	}

	map.mapTypes.set('map_style', slxStyledMap);
	map.setMapTypeId('map_style');

	Promise.all(promises).then(() => {
		map.fitBounds(bounds);
		const zoom = map.getZoom() > 15 ? 15 : map.getZoom() - 1;
		map.setZoom(zoom);
	});
}

function setMarker(data) {
	return new Promise((resolve, reject) => {
		if (
			(!data.lng || data.lng === '')
			|| (!data.lat || data.lat === '')
		) {
			// Geolocalisation
			let address = `${data.street_1}, ${data.city}, ${data.zipcode || ''}`;
			_geocoder.geocode({address}, (results, status) => {
				if (status === _g.maps.GeocoderStatus.OK) {
					createMarker(results[0].geometry.location, data);
					//console.log('geocode address: ' + address, results[0].geometry.location);
				} else {
					console.error(`Can't geocode address: ${address}`);
					//throw new Error('Can\'t geocode address: ' + address);
				}
				resolve();
			});
		} else {
			createMarker(new _g.maps.LatLng(data.lat, data.lng), data);
			resolve();
		}
	});
}

function createMarker(position, data) {
	const hash = getHashedPosition(position);
	if (!markers[hash]) {
		const marker = new _g.maps.Marker({
			map,
			position
		});
		setIcon(marker, false, ' ');
		marker.addListener('click', event => onMarkerClick(event, hash));
		markers[hash] = {
			places: [data],
			marker
		};
		bounds.extend(marker.getPosition());
		markerCount++;
	} else {
		markers[hash].places.push(data);
		const text = markers[hash].places.length.toString();
		setIcon(markers[hash].marker, false, text);
	}
}

function setIcon(marker, active = false, label = false) {
	const color = active ? '#000000' : '#FFFFFF';
	const colorFill = active ? '#FFFFFF' : '#000000';
	const text = label || marker.getLabel().text;
	marker.setIcon({
		anchor: new _g.maps.Point(12.4, 41.5),
		path: 'M12.4,0.5C5.8,0.5,0.5,5.8,0.5,12.4s11.9,28.1,11.9,28.1S24.3,19,24.3,12.4 S19,0.5,12.4,0.5z',
		fillOpacity: 1,
		fillColor: colorFill,
		scale: 1,
		strokeColor: color,
		strokeWeight: 1,
		labelOrigin: new _g.maps.Point(12, 15)
	});
	marker.setLabel({
		color,
		text
	});
}

function onMarkerClick(event, hash) {
	const marker = markers[hash];
	const activate = marker !== activeMarker;
	let places;
	if (activeMarker) {
		setIcon(activeMarker.marker, false);
		activeMarker = null;
	}
	if (activate) {
		setIcon(marker.marker, true);
		activeMarker = marker;
		places = marker.places;
	}
	marker.isActive = !marker.isActive;
	events.emit('clickMarker', places);
}

function getHashedPosition(position) {
	return `${position.lat()}:${position.lng()}`;
}

export default {
	start,
	events
};
